

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import styles from './StudyManagement.module.css';

// const StudyManagement = () => {
//     const navigate = useNavigate();

//     return (
//         <div className={styles.page}>
//             <div className={styles.header}>
//                 <h1 className={styles.title}>Study Management</h1>
//             </div>

//             <div className={styles.card}>
//                 <h2>Available Studies</h2>

//                 {/* Add buttons to navigate to surveys */}
//                 <div style={{ display: 'flex', gap: '10px', marginTop: '20px', alignItems: 'center', justifyContent: 'center' }}>
//                     <button
//                         onClick={() => navigate('/survey/1')}
//                         className={styles.addButton}
//                     >
//                         Start Survey
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StudyManagement;


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styles from './StudyManagement.module.css';
// import { getStudy } from '../../Config/api';

// const StudyManagement = () => {
//     const navigate = useNavigate();
//     const [surveyStatus, setSurveyStatus] = useState(null);
//     const [isLoading, setIsLoading] = useState(true);

//     // Get userId from localStorage
//     const getUserId = () => {
//         try {
//             const user = JSON.parse(localStorage.getItem('user') || '{}');
//             return user.userId || user.user_id || user.id || null;
//         } catch (error) {
//             console.error('Error getting userId:', error);
//             return null;
//         }
//     };

//     const userId = getUserId();
//     const studyId = 1; // Your study ID

//     // Check survey status on component mount
//     useEffect(() => {
//         const checkSurveyStatus = async () => {
//             if (!userId) {
//                 setIsLoading(false);
//                 return;
//             }

//             try {
//                 setIsLoading(true);
//                 const response = await getStudy(userId, studyId);
//                 const status = response?.data?.status;

//                 console.log('Survey status:', status);
//                 setSurveyStatus(status);
//             } catch (error) {
//                 console.error('Error checking survey status:', error);
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         checkSurveyStatus();
//     }, [userId]);

//     const handleSurveyClick = () => {
//         if (surveyStatus === 'submitted') {
//             navigate('/survey/1');
//         } else {
//             navigate('/survey/1');
//         }
//     };

//     return (
//         <div className={styles.page}>
//             <div className={styles.header}>
//                 <h1 className={styles.title}>Study Management</h1>
//             </div>

//             <div className={styles.card}>
//                 <h2>Available Studies</h2>

//                 <div style={{ display: 'flex', gap: '10px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
//                     {isLoading ? (
//                         <p>Loading...</p>
//                     ) : surveyStatus === 'submitted' ? (
//                         <>
//                             <div style={{ textAlign: 'center', padding: '20px' }}>
//                                 <div style={{ fontSize: '48px', color: '#22c55e', marginBottom: '10px' }}>✓</div>
//                                 <h3 style={{ color: '#22c55e', marginBottom: '10px' }}>Survey Completed</h3>
//                                 <p style={{ color: '#64748b', marginBottom: '20px' }}>
//                                     You have already submitted this survey. Thank you for your participation!
//                                 </p>
//                                 <button
//                                     onClick={() => navigate('/survey/1')}
//                                     className={styles.addButton}
//                                     style={{ backgroundColor: '#22c55e' }}
//                                 >
//                                     View Submission
//                                 </button>
//                             </div>
//                         </>
//                     ) : surveyStatus === 'draft' ? (
//                         <>
//                             <p style={{ color: '#f59e0b', marginBottom: '10px' }}>
//                                 You have an active draft in progress.
//                             </p>
//                             <button
//                                 onClick={handleSurveyClick}
//                                 className={styles.addButton}
//                             >
//                                 Continue Survey
//                             </button>
//                         </>
//                     ) : (
//                         <button
//                             onClick={handleSurveyClick}
//                             className={styles.addButton}
//                         >
//                             Start Survey
//                         </button>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default StudyManagement;
// import React, { useState, useEffect, useRef } from 'react';
// import { Search, Plus, Lock, FileText, MoreHorizontal, ChevronLeft, ChevronRight } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import styles from './StudyManagement.module.css';

// const initialSubjects = [
//     {
//         siteName: "VEN-385 - Veronica Children's Clinic",
//         subjectId: 'VEN-001',
//         subjectInitials: 'RSD',
//         dateOfEnrollment: '27-Aug-2025',
//         screeningNumber: 'VEN-001',
//         enrollmentStatus: 'Screening',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 63
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         subjectId: 'GGH-001',
//         subjectInitials: 'FSD',
//         dateOfEnrollment: '21-Aug-2025',
//         screeningNumber: 'GGH-001',
//         enrollmentStatus: 'Enrolled',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 100
//     },
//     {
//         siteName: 'CMC-142 - City Medical Center',
//         subjectId: 'CMC-002',
//         subjectInitials: 'LKT',
//         dateOfEnrollment: '12-Jul-2025',
//         screeningNumber: 'CMC-002',
//         enrollmentStatus: 'Screening',
//         dataCaptureIcon: true,
//         lockStatus: 'locked',
//         progress: 0
//     },
//     {
//         siteName: 'STJ-089 - St. Johns Hospital',
//         subjectId: 'SUN-003',
//         subjectInitials: 'PKD',
//         dateOfEnrollment: '03-Sep-2025',
//         screeningNumber: 'SUN-003',
//         enrollmentStatus: 'Enrolled',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 45
//     },
//     {
//         siteName: 'MHC-256 - Metro Health Clinic',
//         subjectId: 'LAK-004',
//         subjectInitials: 'TJR',
//         dateOfEnrollment: '15-Jun-2025',
//         screeningNumber: 'LAK-004',
//         enrollmentStatus: 'Completed',
//         dataCaptureIcon: true,
//         lockStatus: 'locked',
//         progress: 100
//     },
//     {
//         siteName: 'VEN-385 - Veronica Children\'s Clinic',
//         subjectId: 'VEN-002',
//         subjectInitials: 'NVR',
//         dateOfEnrollment: '29-Aug-2025',
//         screeningNumber: 'VEN-002',
//         enrollmentStatus: 'Screening',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 30
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         subjectId: 'GGH-002',
//         subjectInitials: 'KPS',
//         dateOfEnrollment: '05-Sep-2025',
//         screeningNumber: 'GGH-002',
//         enrollmentStatus: 'Enrolled',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 75
//     },
//     {
//         siteName: 'VEN-385 - Veronica Children\'s Clinic',
//         subjectId: 'VEN-003',
//         subjectInitials: 'MHT',
//         dateOfEnrollment: '19-May-2025',
//         screeningNumber: 'VEN-003',
//         enrollmentStatus: 'Withdrawn',
//         dataCaptureIcon: true,
//         lockStatus: 'locked',
//         progress: 0
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         subjectId: 'GGH-003',
//         subjectInitials: 'SNR',
//         dateOfEnrollment: '23-Jul-2025',
//         screeningNumber: 'GGH-003',
//         enrollmentStatus: 'Enrolled',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 100
//     },
//     {
//         siteName: 'CMC-142 - City Medical Center',
//         subjectId: 'CMC-001',
//         subjectInitials: 'VKM',
//         dateOfEnrollment: '10-Apr-2025',
//         screeningNumber: 'CMC-001',
//         enrollmentStatus: 'Completed',
//         dataCaptureIcon: true,
//         lockStatus: 'locked',
//         progress: 100
//     },
//     {
//         siteName: 'STJ-089 - St. Johns Hospital',
//         subjectId: 'STJ-001',
//         subjectInitials: 'DSR',
//         dateOfEnrollment: '01-Oct-2025',
//         screeningNumber: 'STJ-001',
//         enrollmentStatus: 'Screening',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 50
//     }
// ];

// const DataCapture = () => {
//     const navigate = useNavigate();
//     const [subjects, setSubjects] = useState(initialSubjects);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [openActionMenu, setOpenActionMenu] = useState(null);
//     const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
//     const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//     const [drawerMode, setDrawerMode] = useState('create');
//     const menuRef = useRef(null);

//     const [user, setUser] = useState(null);

//     useEffect(() => {
//         const userData = localStorage.getItem('user');
//         if (userData) {
//             const parsedUser = JSON.parse(userData);
//             setUser(parsedUser);
//         }
//     }, []);

//     const userRoleName = user?.role?.roleName;
//     const isCROAdmin = userRoleName === 'CRO Admin';
//     const isSponsor = userRoleName === 'Sponsor';
//     const isPIUser = userRoleName === 'Principal Investigator' || userRoleName === 'Co-ordinator member';

//     const canWrite = isCROAdmin || isSponsor || isPIUser;

//     const [formData, setFormData] = useState({
//         siteName: '',
//         subjectId: '',
//         subjectInitials: '',
//         enrollmentDate: '',
//         enrollmentStatus: 'screening'
//     });

//     const studyData = {
//         studyTitle: '7 Hills Study',
//         protocolNumber: '35078',
//         totalEnrolments: subjects.length,
//         enrollmentProgress: 60,
//         drafts: 3,
//         completed: subjects.filter(s => s.enrollmentStatus === 'Completed').length
//     };

//     const sites = [
//         {
//             id: 1,
//             code: 'GGH-297',
//             name: 'GG Hospital',
//             enrolled: subjects.filter(s => s.siteName.includes('GGH-297')).length,
//             maxEnrollment: 5,
//             progress: 0
//         },
//         {
//             id: 2,
//             code: 'VEN-385',
//             name: "Veronica Children's Clinic",
//             enrolled: subjects.filter(s => s.siteName.includes('VEN-385')).length,
//             maxEnrollment: 5,
//             progress: 0
//         },
//         {
//             id: 3,
//             code: 'CMC-142',
//             name: 'City Medical Center',
//             enrolled: subjects.filter(s => s.siteName.includes('CMC-142')).length,
//             maxEnrollment: 5,
//             progress: 0
//         },
//         {
//             id: 4,
//             code: 'STJ-089',
//             name: 'St. Johns Hospital',
//             enrolled: subjects.filter(s => s.siteName.includes('STJ-089')).length,
//             maxEnrollment: 5,
//             progress: 0
//         },
//         {
//             id: 5,
//             code: 'MHC-256',
//             name: 'Metro Health Clinic',
//             enrolled: subjects.filter(s => s.siteName.includes('MHC-256')).length,
//             maxEnrollment: 5,
//             progress: 0
//         }
//     ];

//     sites.forEach(site => {
//         site.progress = Math.round((site.enrolled / site.maxEnrollment) * 100);
//     });

//     const selectedSite = formData.siteName
//         ? sites.find(site => `${site.code} - ${site.name}` === formData.siteName) || sites[0]
//         : sites[0];

//     const generateSubjectId = (siteCode) => {
//         if (!siteCode) return '';
//         const siteSubjects = subjects.filter(s => s.subjectId.startsWith(siteCode));
//         const lastNumber = siteSubjects.length;
//         return `${siteCode}-${String(lastNumber + 1).padStart(3, '0')}`;
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => {
//             const updated = { ...prev, [name]: value };

//             if (name === 'siteName' && drawerMode === 'create') {
//                 const site = sites.find(s => `${s.code} - ${s.name}` === value);
//                 if (site) {
//                     updated.subjectId = generateSubjectId(site.code);
//                 }
//             }

//             return updated;
//         });
//     };

//     const openDrawer = () => {
//         setDrawerMode('create');
//         setFormData({
//             siteName: '',
//             subjectId: '',
//             subjectInitials: '',
//             enrollmentDate: '',
//             enrollmentStatus: 'screening'
//         });
//         setIsDrawerOpen(true);
//     };

//     const convertDateToDisplayFormat = (dateString) => {
//         if (!dateString) return '';

//         const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//         const date = new Date(dateString);
//         const day = date.getDate();
//         const month = months[date.getMonth()];
//         const year = date.getFullYear();

//         return `${String(day).padStart(2, '0')}-${month}-${year}`;
//     };

//     const convertDateFormat = (dateString) => {
//         const months = {
//             'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
//             'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
//             'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
//         };

//         const parts = dateString.split('-');
//         if (parts.length === 3) {
//             const day = parts[0].padStart(2, '0');
//             const month = months[parts[1]];
//             const year = parts[2];
//             return `${year}-${month}-${day}`;
//         }
//         return '';
//     };

//     const capitalizeFirstLetter = (string) => {
//         return string.charAt(0).toUpperCase() + string.slice(1);
//     };

//     const checkSiteEnrollmentLimit = (siteName) => {
//         const site = sites.find(s => `${s.code} - ${s.name}` === siteName);
//         if (site && site.enrolled >= site.maxEnrollment) {
//             return false;
//         }
//         return true;
//     };

//     const handleEnrollSubject = () => {
//         if (!formData.siteName || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }

//         if (!checkSiteEnrollmentLimit(formData.siteName)) {
//             alert(`Enrollment limit reached for this site. Maximum ${selectedSite.maxEnrollment} subjects allowed.`);
//             return;
//         }

//         const newSubject = {
//             siteName: formData.siteName,
//             subjectId: formData.subjectId,
//             subjectInitials: formData.subjectInitials.toUpperCase(),
//             dateOfEnrollment: convertDateToDisplayFormat(formData.enrollmentDate),
//             screeningNumber: formData.subjectId,
//             enrollmentStatus: capitalizeFirstLetter(formData.enrollmentStatus),
//             dataCaptureIcon: true,
//             lockStatus: 'unlocked',
//             progress: 0
//         };

//         setSubjects(prev => [newSubject, ...prev]);
//         setIsDrawerOpen(false);
//         setFormData({
//             siteName: '',
//             subjectId: '',
//             subjectInitials: '',
//             enrollmentDate: '',
//             enrollmentStatus: 'screening'
//         });
//     };

//     const handleCreateAndStartCapture = () => {
//         if (!formData.siteName || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }

//         if (!checkSiteEnrollmentLimit(formData.siteName)) {
//             alert(`Enrollment limit reached for this site. Maximum ${selectedSite.maxEnrollment} subjects allowed.`);
//             return;
//         }

//         const newSubject = {
//             siteName: formData.siteName,
//             subjectId: formData.subjectId,
//             subjectInitials: formData.subjectInitials.toUpperCase(),
//             dateOfEnrollment: convertDateToDisplayFormat(formData.enrollmentDate),
//             screeningNumber: formData.subjectId,
//             enrollmentStatus: capitalizeFirstLetter(formData.enrollmentStatus),
//             dataCaptureIcon: true,
//             lockStatus: 'unlocked',
//             progress: 0
//         };

//         setSubjects(prev => [newSubject, ...prev]);
//         setIsDrawerOpen(false);

//         navigate('/survey/1');
//     };

//     const handleDataCaptureClick = (subject) => {
//         console.log('Starting data capture for subject:', subject);
//         navigate('/survey/1');
//     };

//     const handleUpdateSubject = () => {
//         if (!formData.siteName || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }

//         setSubjects(prev => prev.map(subject =>
//             subject.subjectId === formData.subjectId
//                 ? {
//                     ...subject,
//                     subjectInitials: formData.subjectInitials.toUpperCase(),
//                     dateOfEnrollment: convertDateToDisplayFormat(formData.enrollmentDate),
//                     enrollmentStatus: capitalizeFirstLetter(formData.enrollmentStatus)
//                 }
//                 : subject
//         ));

//         setIsDrawerOpen(false);
//         setFormData({
//             siteName: '',
//             subjectId: '',
//             subjectInitials: '',
//             enrollmentDate: '',
//             enrollmentStatus: 'screening'
//         });
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (menuRef.current && !menuRef.current.contains(event.target)) {
//                 setOpenActionMenu(null);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const handleMenuOpen = (index, event) => {
//         if (openActionMenu === index) {
//             setOpenActionMenu(null);
//         } else {
//             const button = event.currentTarget;
//             const rect = button.getBoundingClientRect();

//             const menuHeight = 230;
//             const menuWidth = 160;
//             const viewportHeight = window.innerHeight;
//             const viewportWidth = window.innerWidth;

//             const spaceBelow = viewportHeight - rect.bottom;
//             const spaceAbove = rect.top;
//             const openUpwards = spaceBelow < menuHeight && spaceAbove > menuHeight;

//             const spaceOnRight = viewportWidth - rect.right;
//             const spaceOnLeft = rect.left;
//             const alignToLeft = spaceOnRight < menuWidth && spaceOnLeft > spaceOnRight;

//             const newPosition = {
//                 top: openUpwards ? rect.top - menuHeight : rect.bottom,
//                 left: alignToLeft ? rect.left - menuWidth + 20 : rect.right - menuWidth
//             };

//             setMenuPosition(newPosition);
//             setOpenActionMenu(index);
//         }
//     };

//     const handleAction = (action, subject) => {
//         console.log(`${action} clicked for subject:`, subject);
//         setOpenActionMenu(null);

//         if (action === 'View') {
//             setDrawerMode('view');
//             setFormData({
//                 siteName: subject.siteName,
//                 subjectId: subject.subjectId,
//                 subjectInitials: subject.subjectInitials,
//                 enrollmentDate: convertDateFormat(subject.dateOfEnrollment),
//                 enrollmentStatus: subject.enrollmentStatus.toLowerCase()
//             });
//             setIsDrawerOpen(true);
//         } else if (action === 'Edit') {
//             setDrawerMode('edit');
//             setFormData({
//                 siteName: subject.siteName,
//                 subjectId: subject.subjectId,
//                 subjectInitials: subject.subjectInitials,
//                 enrollmentDate: convertDateFormat(subject.dateOfEnrollment),
//                 enrollmentStatus: subject.enrollmentStatus.toLowerCase()
//             });
//             setIsDrawerOpen(true);
//         } else if (action === 'Delete') {
//             if (window.confirm(`Are you sure you want to delete subject ${subject.subjectId}?`)) {
//                 setSubjects(prev => prev.filter(s => s.subjectId !== subject.subjectId));
//             }
//         } else if (action === 'Lock Subject') {
//             setSubjects(prev => prev.map(s =>
//                 s.subjectId === subject.subjectId
//                     ? { ...s, lockStatus: s.lockStatus === 'locked' ? 'unlocked' : 'locked' }
//                     : s
//             ));
//         } else if (action === 'History') {
//             console.log('Showing history for:', subject.subjectId);
//         }
//     };

//     const getDrawerTitle = () => {
//         if (drawerMode === 'create') return 'Create New Subject';
//         if (drawerMode === 'edit') return 'Edit Subject';
//         if (drawerMode === 'view') return 'View Subject';
//         return 'Subject Details';
//     };

//     const isFormDisabled = drawerMode === 'view';

//     return (
//         <div className={styles.container}>
//             <div className={styles.pageHeader}>
//                 <h1 className={styles.mainTitle}>Data Capture</h1>
//                 <p className={styles.subtitle}>Electronic Data Capture (EDC) system for clinical data collection</p>
//             </div>

//             <div className={styles.cardsSection}>
//                 <div className={styles.infoCards}>
//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Study Title</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.studyTitle}</div>
//                         <div className={styles.infoCardSubValue}>{studyData.protocolNumber}</div>
//                     </div>

//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Site Name</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{sites.length} Sites</div>
//                         <div className={styles.infoCardSubValue}>Active Sites</div>
//                     </div>

//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Total Enrolments</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.totalEnrolments}</div>
//                     </div>

//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Enrollment Progress</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.enrollmentProgress}%</div>
//                     </div>

//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Drafts</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.drafts}</div>
//                     </div>

//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Completed</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.completed}</div>
//                     </div>
//                 </div>
//             </div>

//             <div className={styles.tableContainer}>
//                 <div className={styles.tableHeader}>
//                     <div className={styles.tableHeaderTop}>
//                         <h2 className={styles.tableTitle}>Subject Management</h2>
//                         {canWrite && (
//                             <button className={styles.createButton} onClick={openDrawer}>
//                                 <Plus size={18} />
//                                 Create Subject
//                             </button>
//                         )}
//                     </div>

//                     <div className={styles.tableActions}>
//                         <div className={styles.searchContainer}>
//                             <Search className={styles.searchIcon} size={18} />
//                             <input
//                                 type="text"
//                                 placeholder="Search..."
//                                 value={searchTerm}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 className={styles.searchInput}
//                             />
//                         </div>

//                         <div className={styles.actionButtons}>
//                             <button className={styles.actionButton}>Customize</button>
//                             <button className={styles.actionButton}>Export</button>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={styles.tableWrapper}>
//                     <table className={styles.table}>
//                         <thead className={styles.tableHead}>
//                             <tr>
//                                 <th className={styles.tableHeadCell}>
//                                     Site Name <span className={styles.sortIcon}>↕</span>
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Subject ID <span className={styles.sortIcon}>↕</span>
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Subject Initials <span className={styles.sortIcon}>↕</span>
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Date of Enrollment <span className={styles.sortIcon}>↕</span>
//                                 </th>
//                                 {/* <th className={styles.tableHeadCell}>
//                                     Screening Number <span className={styles.sortIcon}>↕</span>
//                                 </th> */}
//                                 <th className={styles.tableHeadCell}>
//                                     Enrollment Status <span className={styles.sortIcon}>↕</span>
//                                 </th>
//                                 <th className={styles.tableHeadCell}>Progress</th>
//                                 <th className={styles.tableHeadCell}>Data Capture</th>
//                                 <th className={styles.tableHeadCell}>
//                                     Lock Status <span className={styles.sortIcon}>↕</span>
//                                 </th>
//                                 <th className={styles.tableHeadCell}>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className={styles.tableBody}>
//                             {subjects.map((subject, index) => (
//                                 <tr key={index} className={styles.tableRow}>
//                                     <td className={styles.tableCell}>{subject.siteName}</td>
//                                     <td className={styles.tableCellBold}>{subject.subjectId}</td>
//                                     <td className={styles.tableCell}>{subject.subjectInitials}</td>
//                                     <td className={styles.tableCell}>{subject.dateOfEnrollment}</td>
//                                     {/* <td className={styles.tableCell}>{subject.screeningNumber}</td> */}
//                                     <td className={styles.tableCell}>
//                                         <span className={`${styles.statusBadge} ${subject.enrollmentStatus === 'Screening'
//                                             ? styles.statusScreening
//                                             : styles.statusEnrolled
//                                             }`}>
//                                             {subject.enrollmentStatus}
//                                         </span>
//                                     </td>
//                                     <td className={styles.tableCell}>
//                                         <span className={styles.progressText}>{subject.progress}%</span>
//                                     </td>
//                                     <td className={styles.tableCellCenter}>
//                                         {subject.dataCaptureIcon && (
//                                             <button
//                                                 onClick={() => handleDataCaptureClick(subject)}
//                                                 className={styles.dataCaptureButton}
//                                                 title="Start Data Capture"
//                                             >
//                                                 <FileText size={18} className={styles.icon} />
//                                             </button>
//                                         )}
//                                     </td>
//                                     <td className={styles.tableCellCenter}>
//                                         <Lock
//                                             size={18}
//                                             className={subject.lockStatus === 'locked' ? styles.iconLocked : styles.iconLock}
//                                         />
//                                     </td>
//                                     <td className={styles.tableCellCenter}>
//                                         <div className={styles.actionMenuWrapper} ref={openActionMenu === index ? menuRef : null}>
//                                             <button
//                                                 className={styles.moreButton}
//                                                 onClick={(e) => handleMenuOpen(index, e)}
//                                             >
//                                                 <MoreHorizontal size={18} />
//                                             </button>

//                                             {openActionMenu === index && (
//                                                 <div
//                                                     className={styles.actionMenu}
//                                                     style={{
//                                                         top: `${menuPosition.top}px`,
//                                                         left: `${menuPosition.left}px`
//                                                     }}
//                                                 >
//                                                     <button
//                                                         className={styles.actionMenuItem}
//                                                         onClick={() => handleAction('View', subject)}
//                                                     >
//                                                         View
//                                                     </button>

//                                                     {canWrite && (
//                                                         <>
//                                                             <button
//                                                                 className={styles.actionMenuItem}
//                                                                 onClick={() => handleAction('Edit', subject)}
//                                                             >
//                                                                 Edit
//                                                             </button>
//                                                             <button
//                                                                 className={styles.actionMenuItem}
//                                                                 onClick={() => handleAction('Lock Subject', subject)}
//                                                             >
//                                                                 {subject.lockStatus === 'locked' ? 'Unlock Subject' : 'Lock Subject'}
//                                                             </button>
//                                                             <button
//                                                                 className={styles.actionMenuItem}
//                                                                 onClick={() => handleAction('History', subject)}
//                                                             >
//                                                                 History
//                                                             </button>
//                                                             <button
//                                                                 className={`${styles.actionMenuItem} ${styles.actionMenuItemDanger}`}
//                                                                 onClick={() => handleAction('Delete', subject)}
//                                                             >
//                                                                 Delete
//                                                             </button>
//                                                         </>
//                                                     )}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>

//                 <div className={styles.pagination}>
//                     <div className={styles.rowsPerPage}>
//                         <span className={styles.paginationLabel}>Rows per page:</span>
//                         <select
//                             value={rowsPerPage}
//                             onChange={(e) => setRowsPerPage(Number(e.target.value))}
//                             className={styles.rowsSelect}
//                         >
//                             <option value={10}>10</option>
//                             <option value={25}>25</option>
//                             <option value={50}>50</option>
//                         </select>
//                     </div>

//                     <div className={styles.paginationControls}>
//                         <span className={styles.pageInfo}>Page 1 of 1</span>
//                         <div className={styles.paginationButtons}>
//                             <button className={styles.paginationButton}>
//                                 <ChevronLeft size={18} />
//                             </button>
//                             <button className={styles.paginationButton}>
//                                 <ChevronLeft size={18} />
//                             </button>
//                             <button className={styles.paginationButton}>
//                                 <ChevronRight size={18} />
//                             </button>
//                             <button className={styles.paginationButton}>
//                                 <ChevronRight size={18} />
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {isDrawerOpen && (
//                 <>
//                     <div className={styles.backdrop} onClick={() => setIsDrawerOpen(false)}></div>

//                     <div className={styles.drawer}>
//                         <div className={styles.drawerHeader}>
//                             <h2 className={styles.drawerTitle}>{getDrawerTitle()}</h2>
//                             <button className={styles.closeButton} onClick={() => setIsDrawerOpen(false)}>
//                                 ✕
//                             </button>
//                         </div>

//                         <div className={styles.drawerContent}>
//                             <form className={styles.form}>
//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Site Name <span className={styles.required}>*</span>
//                                     </label>
//                                     <select
//                                         className={styles.input}
//                                         name="siteName"
//                                         value={formData.siteName}
//                                         onChange={handleInputChange}
//                                         disabled={isFormDisabled}
//                                     >
//                                         {drawerMode === 'create' ? (
//                                             <>
//                                                 <option value="">Select a site</option>
//                                                 {sites.map(site => (
//                                                     <option
//                                                         key={site.id}
//                                                         value={`${site.code} - ${site.name}`}
//                                                         disabled={site.enrolled >= site.maxEnrollment}
//                                                     >
//                                                         {site.code} - {site.name} ({site.enrolled}/{site.maxEnrollment})
//                                                     </option>
//                                                 ))}
//                                             </>
//                                         ) : (
//                                             <option value={formData.siteName}>{formData.siteName}</option>
//                                         )}
//                                     </select>
//                                     <p className={styles.helperText}>
//                                         Site code, and Site Name automatically loaded, for PI - read-only
//                                     </p>
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Subject ID <span className={styles.required}>*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         className={styles.input}
//                                         name="subjectId"
//                                         value={formData.subjectId}
//                                         onChange={handleInputChange}
//                                         placeholder="Auto-generated"
//                                         disabled={isFormDisabled}
//                                         readOnly
//                                     />
//                                     <p className={styles.helperText}>
//                                         Auto-generated with sitecode
//                                     </p>
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Subject Initials <span className={styles.required}>*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         className={styles.input}
//                                         name="subjectInitials"
//                                         value={formData.subjectInitials}
//                                         onChange={handleInputChange}
//                                         placeholder="E.G., JD"
//                                         disabled={isFormDisabled}
//                                     />
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Enrollment Date <span className={styles.required}>*</span>
//                                     </label>
//                                     <input
//                                         type="date"
//                                         className={styles.input}
//                                         name="enrollmentDate"
//                                         value={formData.enrollmentDate}
//                                         onChange={handleInputChange}
//                                         disabled={isFormDisabled}
//                                     />
//                                     <p className={styles.helperText}>
//                                         Dates restricted to study period
//                                     </p>
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Enrollment Status <span className={styles.required}>*</span>
//                                     </label>
//                                     <select
//                                         className={styles.input}
//                                         name="enrollmentStatus"
//                                         value={formData.enrollmentStatus}
//                                         onChange={handleInputChange}
//                                         disabled={isFormDisabled}
//                                     >
//                                         <option value="screening">Screening</option>
//                                         <option value="enrolled">Enrolled</option>
//                                         <option value="completed">Completed</option>
//                                         <option value="withdrawn">Withdrawn</option>
//                                         <option value="discontinued">Discontinued</option>
//                                     </select>
//                                     <p className={styles.helperText}>
//                                         Screening, Enrolled, Completed, Withdrawn, Discontinued
//                                     </p>
//                                 </div>

//                                 {formData.siteName && (
//                                     <div className={styles.formGroup}>
//                                         <label className={styles.label}>Site Enrollment Status</label>
//                                         <div className={styles.statusInfo}>
//                                             <span className={styles.statusIcon}>✓</span>
//                                             <div>
//                                                 <p className={styles.statusTitle}>Enrollment Status</p>
//                                                 <p className={styles.statusSubtitle}>
//                                                     {selectedSite.code} - {selectedSite.name}
//                                                 </p>
//                                                 <p className={styles.statusDetail}>
//                                                     {selectedSite.enrolled} of {selectedSite.maxEnrollment} subjects enrolled
//                                                 </p>
//                                                 <div className={styles.progressBar}>
//                                                     <div
//                                                         className={styles.progressFill}
//                                                         style={{ width: `${selectedSite.progress}%` }}
//                                                     ></div>
//                                                 </div>
//                                                 <p className={styles.statusText}>
//                                                     {selectedSite.enrolled < selectedSite.maxEnrollment ? (
//                                                         <span className={styles.greenText}>
//                                                             ✓ {selectedSite.maxEnrollment - selectedSite.enrolled} enrollment slot{selectedSite.maxEnrollment - selectedSite.enrolled !== 1 ? 's' : ''} remaining
//                                                         </span>
//                                                     ) : (
//                                                         <span className={styles.redText}>
//                                                             ✕ Enrollment limit reached
//                                                         </span>
//                                                     )}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </form>
//                         </div>

//                         <div className={styles.drawerFooter}>
//                             {drawerMode === 'view' ? (
//                                 <button className={styles.cancelButton} onClick={() => setIsDrawerOpen(false)}>
//                                     Close
//                                 </button>
//                             ) : drawerMode === 'edit' ? (
//                                 <>
//                                     <button className={styles.cancelButton} onClick={() => setIsDrawerOpen(false)}>
//                                         Cancel
//                                     </button>
//                                     <button className={styles.primaryButton} onClick={handleUpdateSubject}>
//                                         Save Changes
//                                     </button>
//                                 </>
//                             ) : (
//                                 <>
//                                     <button className={styles.cancelButton} onClick={() => setIsDrawerOpen(false)}>
//                                         Cancel
//                                     </button>
//                                     <button className={styles.enrollButton} onClick={handleEnrollSubject}>
//                                         Enroll New Subject
//                                     </button>
//                                     <button className={styles.primaryButton} onClick={handleCreateAndStartCapture}>
//                                         Create and Start Capture
//                                     </button>
//                                 </>
//                             )}
//                         </div>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default DataCapture;


// import React, { useState, useEffect, useRef } from 'react';
// import { Search, Plus, Lock, FileText, MoreHorizontal, ChevronLeft, ChevronRight, ChevronDown, X } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import styles from './StudyManagement.module.css';

// const DEFAULT_USER_SITE_ID = 1; // GGH-297 - GG Hospital

// const initialSubjects = [
//     {
//         siteName: "GGH-297 - GG Hospital",
//         siteId: 1,
//         subjectId: 'GGH-001',
//         subjectInitials: 'FSD',
//         dateOfEnrollment: '21-Aug-2025',
//         screeningNumber: 'GGH-001',
//         enrollmentStatus: 'Enrolled',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 100
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         siteId: 1,
//         subjectId: 'GGH-002',
//         subjectInitials: 'RSD',
//         dateOfEnrollment: '27-Aug-2025',
//         screeningNumber: 'GGH-002',
//         enrollmentStatus: 'Screening',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 63
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         siteId: 1,
//         subjectId: 'GGH-003',
//         subjectInitials: 'LKT',
//         dateOfEnrollment: '12-Sep-2025',
//         screeningNumber: 'GGH-003',
//         enrollmentStatus: 'Screening',
//         dataCaptureIcon: true,
//         lockStatus: 'locked',
//         progress: 0
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         siteId: 1,
//         subjectId: 'GGH-004',
//         subjectInitials: 'PKD',
//         dateOfEnrollment: '03-Sep-2025',
//         screeningNumber: 'GGH-004',
//         enrollmentStatus: 'Enrolled',
//         dataCaptureIcon: true,
//         lockStatus: 'unlocked',
//         progress: 45
//     },
//     {
//         siteName: 'GGH-297 - GG Hospital',
//         siteId: 1,
//         subjectId: 'GGH-005',
//         subjectInitials: 'TJR',
//         dateOfEnrollment: '15-Jun-2025',
//         screeningNumber: 'GGH-005',
//         enrollmentStatus: 'Completed',
//         dataCaptureIcon: true,
//         lockStatus: 'locked',
//         progress: 100
//     }
// ];

// const MAX_SUBJECTS_PER_USER = 20;

// const DataCapture = () => {
//     const navigate = useNavigate();
//     const [subjects, setSubjects] = useState(initialSubjects);
//     const [sites, setSites] = useState([]);
//     const [loadingSites, setLoadingSites] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [openActionMenu, setOpenActionMenu] = useState(null);
//     const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
//     const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//     const [drawerMode, setDrawerMode] = useState('create');
//     const [showLimitModal, setShowLimitModal] = useState(false);
//     const menuRef = useRef(null);
//     const [selectedTopSite, setSelectedTopSite] = useState(null);
//     const [user, setUser] = useState(null);
//     const [userAssignedSiteId, setUserAssignedSiteId] = useState(DEFAULT_USER_SITE_ID);
//     const [userSubjectsCount, setUserSubjectsCount] = useState(0);

//     const getToken = () => {
//         return localStorage.getItem('token');
//     };

//     useEffect(() => {
//         const userData = localStorage.getItem('user');
//         if (userData) {
//             const parsedUser = JSON.parse(userData);
//             setUser(parsedUser);

//             if (parsedUser.siteId) {
//                 setUserAssignedSiteId(parsedUser.siteId);
//                 localStorage.setItem('userAssignedSiteId', parsedUser.siteId.toString());
//             } else {
//                 // Use default site
//                 setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
//                 localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
//             }
//         } else {
//             // No user data, use default
//             setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
//             localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
//         }
//     }, []);

//     useEffect(() => {
//         fetchSites();
//     }, []);

//     // Count user's subjects
//     useEffect(() => {
//         const count = subjects.length;
//         setUserSubjectsCount(count);
//     }, [subjects]);

//     const fetchSites = async () => {
//         try {
//             setLoadingSites(true);
//             const token = getToken();
//             const response = await fetch('http://localhost:5000/api/sites/dropdown/list', {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });
//             const data = await response.json();
//             if (data.success) {
//                 console.log('✅ Sites fetched:', data.data?.length || 0);
//                 const formattedSites = data.data.map(site => ({
//                     id: site.site_id,
//                     code: site.site_code,
//                     name: site.site_name,
//                     enrolled: subjects.filter(s => s.siteId === site.site_id).length,
//                     maxEnrollment: 5,
//                     progress: 0
//                 }));
//                 setSites(formattedSites);

//                 // Set the selected top site to user's assigned site
//                 const assignedSite = formattedSites.find(s => s.id === userAssignedSiteId);
//                 if (assignedSite) {
//                     setSelectedTopSite(assignedSite);
//                 } else if (formattedSites.length > 0) {
//                     setSelectedTopSite(formattedSites[0]);
//                 }
//             } else {
//                 console.error('❌ Failed to fetch sites:', data.message);
//                 setSites([]);
//             }
//         } catch (error) {
//             console.error('❌ Error fetching sites:', error);
//             setSites([]);
//         } finally {
//             setLoadingSites(false);
//         }
//     };

//     const userRoleName = user?.role?.roleName;
//     const isCROAdmin = userRoleName === 'CRO Admin';
//     const isSponsor = userRoleName === 'Sponsor';
//     const isPIUser = userRoleName === 'Principal Investigator' || userRoleName === 'Co-ordinator member';

//     const canWrite = isCROAdmin || isSponsor || isPIUser;

//     const [formData, setFormData] = useState({
//         siteName: '',
//         siteId: null,
//         subjectId: '',
//         subjectInitials: '',
//         enrollmentDate: '',
//         enrollmentStatus: 'screening'
//     });

//     const studyData = {
//         totalEnrolments: subjects.length,
//         drafts: subjects.filter(s => s.progress > 0 && s.progress < 100).length,
//         completed: subjects.filter(s => s.progress === 100).length
//     };

//     useEffect(() => {
//         if (sites.length > 0) {
//             const updatedSites = sites.map(site => ({
//                 ...site,
//                 enrolled: subjects.filter(s => s.siteId === site.id).length,
//                 progress: Math.round((subjects.filter(s => s.siteId === site.id).length / site.maxEnrollment) * 100)
//             }));
//             setSites(updatedSites);

//             if (selectedTopSite) {
//                 const updatedSelectedSite = updatedSites.find(s => s.id === selectedTopSite.id);
//                 if (updatedSelectedSite) {
//                     setSelectedTopSite(updatedSelectedSite);
//                 }
//             }
//         }
//     }, [subjects]);

//     const selectedSite = formData.siteId
//         ? sites.find(site => site.id === formData.siteId) || (sites.length > 0 ? sites[0] : null)
//         : (sites.length > 0 ? sites[0] : null);

//     const generateSubjectId = (siteCode) => {
//         if (!siteCode) return '';
//         const siteSubjects = subjects.filter(s => s.subjectId.startsWith(siteCode));
//         const lastNumber = siteSubjects.length;
//         return `${siteCode}-${String(lastNumber + 1).padStart(3, '0')}`;
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => {
//             const updated = { ...prev, [name]: value };

//             if (name === 'siteId' && drawerMode === 'create') {
//                 const siteId = parseInt(value);
//                 const site = sites.find(s => s.id === siteId);
//                 if (site) {
//                     updated.siteId = siteId;
//                     updated.siteName = `${site.code} - ${site.name}`;
//                     updated.subjectId = generateSubjectId(site.code);
//                 }
//             }

//             return updated;
//         });
//     };

//     const openDrawer = () => {
//         // Check subject limit before opening drawer
//         if (userSubjectsCount >= MAX_SUBJECTS_PER_USER) {
//             setShowLimitModal(true);
//             return;
//         }

//         setDrawerMode('create');

//         if (userAssignedSiteId) {
//             const assignedSite = sites.find(s => s.id === userAssignedSiteId);
//             if (assignedSite) {
//                 setFormData({
//                     siteName: `${assignedSite.code} - ${assignedSite.name}`,
//                     siteId: userAssignedSiteId,
//                     subjectId: generateSubjectId(assignedSite.code),
//                     subjectInitials: '',
//                     enrollmentDate: '',
//                     enrollmentStatus: 'screening'
//                 });
//             } else {
//                 setFormData({
//                     siteName: '',
//                     siteId: null,
//                     subjectId: '',
//                     subjectInitials: '',
//                     enrollmentDate: '',
//                     enrollmentStatus: 'screening'
//                 });
//             }
//         } else {
//             setFormData({
//                 siteName: '',
//                 siteId: null,
//                 subjectId: '',
//                 subjectInitials: '',
//                 enrollmentDate: '',
//                 enrollmentStatus: 'screening'
//             });
//         }

//         setIsDrawerOpen(true);
//     };

//     const convertDateToDisplayFormat = (dateString) => {
//         if (!dateString) return '';

//         const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//         const date = new Date(dateString);
//         const day = date.getDate();
//         const month = months[date.getMonth()];
//         const year = date.getFullYear();

//         return `${String(day).padStart(2, '0')}-${month}-${year}`;
//     };

//     const convertDateFormat = (dateString) => {
//         const months = {
//             'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
//             'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
//             'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
//         };

//         const parts = dateString.split('-');
//         if (parts.length === 3) {
//             const day = parts[0].padStart(2, '0');
//             const month = months[parts[1]];
//             const year = parts[2];
//             return `${year}-${month}-${day}`;
//         }
//         return '';
//     };

//     const capitalizeFirstLetter = (string) => {
//         return string.charAt(0).toUpperCase() + string.slice(1);
//     };

//     const checkSiteEnrollmentLimit = (siteId) => {
//         const site = sites.find(s => s.id === siteId);
//         if (site && site.enrolled >= site.maxEnrollment) {
//             return false;
//         }
//         return true;
//     };

//     const handleEnrollSubject = () => {
//         // Check subject limit
//         if (userSubjectsCount >= MAX_SUBJECTS_PER_USER) {
//             setShowLimitModal(true);
//             setIsDrawerOpen(false);
//             return;
//         }

//         if (!formData.siteId || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }

//         if (!checkSiteEnrollmentLimit(formData.siteId)) {
//             alert(`Enrollment limit reached for this site. Maximum ${selectedSite.maxEnrollment} subjects allowed.`);
//             return;
//         }

//         const newSubject = {
//             siteName: formData.siteName,
//             siteId: formData.siteId,
//             subjectId: formData.subjectId,
//             subjectInitials: formData.subjectInitials.toUpperCase(),
//             dateOfEnrollment: convertDateToDisplayFormat(formData.enrollmentDate),
//             screeningNumber: formData.subjectId,
//             enrollmentStatus: capitalizeFirstLetter(formData.enrollmentStatus),
//             dataCaptureIcon: true,
//             lockStatus: 'unlocked',
//             progress: 0
//         };

//         setSubjects(prev => [newSubject, ...prev]);
//         setIsDrawerOpen(false);
//         setFormData({
//             siteName: '',
//             siteId: null,
//             subjectId: '',
//             subjectInitials: '',
//             enrollmentDate: '',
//             enrollmentStatus: 'screening'
//         });
//     };

//     const handleCreateAndStartCapture = () => {
//         // Check subject limit
//         if (userSubjectsCount >= MAX_SUBJECTS_PER_USER) {
//             setShowLimitModal(true);
//             setIsDrawerOpen(false);
//             return;
//         }

//         if (!formData.siteId || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }

//         if (!checkSiteEnrollmentLimit(formData.siteId)) {
//             alert(`Enrollment limit reached for this site. Maximum ${selectedSite.maxEnrollment} subjects allowed.`);
//             return;
//         }

//         const newSubject = {
//             siteName: formData.siteName,
//             siteId: formData.siteId,
//             subjectId: formData.subjectId,
//             subjectInitials: formData.subjectInitials.toUpperCase(),
//             dateOfEnrollment: convertDateToDisplayFormat(formData.enrollmentDate),
//             screeningNumber: formData.subjectId,
//             enrollmentStatus: capitalizeFirstLetter(formData.enrollmentStatus),
//             dataCaptureIcon: true,
//             lockStatus: 'unlocked',
//             progress: 0
//         };

//         setSubjects(prev => [newSubject, ...prev]);
//         setIsDrawerOpen(false);

//         navigate('/survey/1');
//     };

//     const handleDataCaptureClick = (subject) => {
//         console.log('Starting data capture for subject:', subject);
//         navigate('/survey/1');
//     };

//     const handleUpdateSubject = () => {
//         if (!formData.siteId || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }

//         setSubjects(prev => prev.map(subject =>
//             subject.subjectId === formData.subjectId
//                 ? {
//                     ...subject,
//                     subjectInitials: formData.subjectInitials.toUpperCase(),
//                     dateOfEnrollment: convertDateToDisplayFormat(formData.enrollmentDate),
//                     enrollmentStatus: capitalizeFirstLetter(formData.enrollmentStatus)
//                 }
//                 : subject
//         ));

//         setIsDrawerOpen(false);
//         setFormData({
//             siteName: '',
//             siteId: null,
//             subjectId: '',
//             subjectInitials: '',
//             enrollmentDate: '',
//             enrollmentStatus: 'screening'
//         });
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (menuRef.current && !menuRef.current.contains(event.target)) {
//                 setOpenActionMenu(null);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const handleMenuOpen = (index, event) => {
//         if (openActionMenu === index) {
//             setOpenActionMenu(null);
//         } else {
//             const button = event.currentTarget;
//             const rect = button.getBoundingClientRect();

//             const menuHeight = 230;
//             const menuWidth = 160;
//             const viewportHeight = window.innerHeight;
//             const viewportWidth = window.innerWidth;

//             const spaceBelow = viewportHeight - rect.bottom;
//             const spaceAbove = rect.top;
//             const openUpwards = spaceBelow < menuHeight && spaceAbove > menuHeight;

//             const spaceOnRight = viewportWidth - rect.right;
//             const spaceOnLeft = rect.left;
//             const alignToLeft = spaceOnRight < menuWidth && spaceOnLeft > spaceOnRight;

//             const newPosition = {
//                 top: openUpwards ? rect.top - menuHeight : rect.bottom,
//                 left: alignToLeft ? rect.left - menuWidth + 20 : rect.right - menuWidth
//             };

//             setMenuPosition(newPosition);
//             setOpenActionMenu(index);
//         }
//     };

//     const handleAction = (action, subject) => {
//         console.log(`${action} clicked for subject:`, subject);
//         setOpenActionMenu(null);

//         if (action === 'View') {
//             setDrawerMode('view');
//             setFormData({
//                 siteName: subject.siteName,
//                 siteId: subject.siteId,
//                 subjectId: subject.subjectId,
//                 subjectInitials: subject.subjectInitials,
//                 enrollmentDate: convertDateFormat(subject.dateOfEnrollment),
//                 enrollmentStatus: subject.enrollmentStatus.toLowerCase()
//             });
//             setIsDrawerOpen(true);
//         } else if (action === 'Edit') {
//             setDrawerMode('edit');
//             setFormData({
//                 siteName: subject.siteName,
//                 siteId: subject.siteId,
//                 subjectId: subject.subjectId,
//                 subjectInitials: subject.subjectInitials,
//                 enrollmentDate: convertDateFormat(subject.dateOfEnrollment),
//                 enrollmentStatus: subject.enrollmentStatus.toLowerCase()
//             });
//             setIsDrawerOpen(true);
//         } else if (action === 'Delete') {
//             if (window.confirm(`Are you sure you want to delete subject ${subject.subjectId}?`)) {
//                 setSubjects(prev => prev.filter(s => s.subjectId !== subject.subjectId));
//             }
//         } else if (action === 'Lock Subject') {
//             setSubjects(prev => prev.map(s =>
//                 s.subjectId === subject.subjectId
//                     ? { ...s, lockStatus: s.lockStatus === 'locked' ? 'unlocked' : 'locked' }
//                     : s
//             ));
//         } else if (action === 'History') {
//             console.log('Showing history for:', subject.subjectId);
//         }
//     };

//     const getDrawerTitle = () => {
//         if (drawerMode === 'create') return 'Create New Subject';
//         if (drawerMode === 'edit') return 'Edit Subject';
//         if (drawerMode === 'view') return 'View Subject';
//         return 'Subject Details';
//     };

//     const isFormDisabled = drawerMode === 'view';

//     return (
//         <div className={styles.container}>
//             <div className={styles.pageHeader}>
//                 <h1 className={styles.mainTitle}>Data Capture</h1>
//                 <p className={styles.subtitle}>Electronic Data Capture (EDC) system for clinical data collection</p>
//             </div>

//             <div className={styles.cardsSection}>
//                 <div className={styles.infoCards}>
//                     {/* Site Enrollment Status Card */}
//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Site Enrollment Status</span>
//                         </div>

//                         {selectedTopSite ? (
//                             <div className={styles.topSiteEnrollment}>
//                                 <div className={styles.siteSelector}>
//                                     <select
//                                         className={styles.siteDropdown}
//                                         value={selectedTopSite.id}
//                                         onChange={(e) => {
//                                             const site = sites.find(s => s.id === parseInt(e.target.value));
//                                             setSelectedTopSite(site);
//                                         }}
//                                     >
//                                         {sites.map(site => (
//                                             <option key={site.id} value={site.id}>
//                                                 {site.code} - {site.name}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 <div className={styles.enrollmentInfo}>
//                                     <p className={styles.enrollmentDetail}>
//                                         {selectedTopSite.enrolled} of {selectedTopSite.maxEnrollment} subjects enrolled
//                                     </p>
//                                     <div className={styles.progressBar}>
//                                         <div
//                                             className={styles.progressFill}
//                                             style={{ width: `${selectedTopSite.progress}%` }}
//                                         ></div>
//                                     </div>
//                                     <p className={styles.enrollmentStatusText}>
//                                         {selectedTopSite.enrolled < selectedTopSite.maxEnrollment ? (
//                                             <span className={styles.greenText}>
//                                                 ✓ {selectedTopSite.maxEnrollment - selectedTopSite.enrolled} enrollment slot{selectedTopSite.maxEnrollment - selectedTopSite.enrolled !== 1 ? 's' : ''} remaining
//                                             </span>
//                                         ) : (
//                                             <span className={styles.redText}>
//                                                 ✕ Enrollment limit reached
//                                             </span>
//                                         )}
//                                     </p>
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className={styles.noSiteSelected}>No sites available</div>
//                         )}
//                     </div>

//                     {/* Total Enrollments Card */}
//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Total Enrollments</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.totalEnrolments}</div>
//                         <div className={styles.infoCardSubValue}>All Subjects</div>
//                     </div>

//                     {/* Drafts Card */}
//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Drafts</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.drafts}</div>
//                         <div className={styles.infoCardSubValue}>In Progress</div>
//                     </div>

//                     {/* Completed Card */}
//                     <div className={styles.infoCard}>
//                         <div className={styles.infoCardLabel}>
//                             <FileText size={16} />
//                             <span>Completed</span>
//                         </div>
//                         <div className={styles.infoCardValue}>{studyData.completed}</div>
//                         <div className={styles.infoCardSubValue}>Finished Forms</div>
//                     </div>
//                 </div>
//             </div>

//             <div className={styles.tableContainer}>
//                 <div className={styles.tableHeader}>
//                     <div className={styles.tableHeaderTop}>
//                         <h2 className={styles.tableTitle}>Subject Management</h2>
//                         {canWrite && (
//                             <button className={styles.createButton} onClick={openDrawer}>
//                                 <Plus size={18} />
//                                 Create Subject
//                             </button>
//                         )}
//                     </div>

//                     <div className={styles.tableActions}>
//                         <div className={styles.searchContainer}>
//                             <Search className={styles.searchIcon} size={18} />
//                             <input
//                                 type="text"
//                                 placeholder="Search..."
//                                 value={searchTerm}
//                                 onChange={(e) => setSearchTerm(e.target.value)}
//                                 className={styles.searchInput}
//                             />
//                         </div>

//                         <div className={styles.actionButtons}>
//                             <button className={styles.actionButton}>Customize</button>
//                             <button className={styles.actionButton}>Export</button>
//                         </div>
//                     </div>
//                 </div>

//                 <div className={styles.tableWrapper}>
//                     <table className={styles.table}>
//                         <thead className={styles.tableHead}>
//                             <tr>
//                                 <th className={styles.tableHeadCell}>
//                                     Site Name <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Subject ID <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Subject Initials <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Date of Enrollment <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Screening Number <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>
//                                     Enrollment Status <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>Progress</th>
//                                 <th className={styles.tableHeadCell}>Data Capture</th>
//                                 <th className={styles.tableHeadCell}>
//                                     Lock Status <ChevronDown size={14} className={styles.sortIcon} />
//                                 </th>
//                                 <th className={styles.tableHeadCell}>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className={styles.tableBody}>
//                             {subjects.map((subject, index) => (
//                                 <tr key={index} className={styles.tableRow}>
//                                     <td className={styles.tableCell}>{subject.siteName}</td>
//                                     <td className={styles.tableCellBold}>{subject.subjectId}</td>
//                                     <td className={styles.tableCell}>{subject.subjectInitials}</td>
//                                     <td className={styles.tableCell}>{subject.dateOfEnrollment}</td>
//                                     <td className={styles.tableCell}>{subject.screeningNumber}</td>
//                                     <td className={styles.tableCell}>
//                                         <span className={`${styles.statusBadge} ${subject.enrollmentStatus === 'Screening'
//                                             ? styles.statusScreening
//                                             : styles.statusEnrolled
//                                             }`}>
//                                             {subject.enrollmentStatus}
//                                         </span>
//                                     </td>
//                                     <td className={styles.tableCell}>
//                                         <span className={styles.progressText}>{subject.progress}%</span>
//                                     </td>
//                                     <td className={styles.tableCellCenter}>
//                                         {subject.dataCaptureIcon && (
//                                             <button
//                                                 onClick={() => handleDataCaptureClick(subject)}
//                                                 className={styles.dataCaptureButton}
//                                                 title="Start Data Capture"
//                                             >
//                                                 <FileText size={18} className={styles.icon} />
//                                             </button>
//                                         )}
//                                     </td>
//                                     <td className={styles.tableCellCenter}>
//                                         <Lock
//                                             size={18}
//                                             className={subject.lockStatus === 'locked' ? styles.iconLocked : styles.iconLock}
//                                         />
//                                     </td>
//                                     <td className={styles.tableCellCenter}>
//                                         <div className={styles.actionMenuWrapper} ref={openActionMenu === index ? menuRef : null}>
//                                             <button
//                                                 className={styles.moreButton}
//                                                 onClick={(e) => handleMenuOpen(index, e)}
//                                             >
//                                                 <MoreHorizontal size={18} />
//                                             </button>

//                                             {openActionMenu === index && (
//                                                 <div
//                                                     className={styles.actionMenu}
//                                                     style={{
//                                                         top: `${menuPosition.top}px`,
//                                                         left: `${menuPosition.left}px`
//                                                     }}
//                                                 >
//                                                     <button
//                                                         className={styles.actionMenuItem}
//                                                         onClick={() => handleAction('View', subject)}
//                                                     >
//                                                         View
//                                                     </button>

//                                                     {canWrite && (
//                                                         <>
//                                                             <button
//                                                                 className={styles.actionMenuItem}
//                                                                 onClick={() => handleAction('Edit', subject)}
//                                                             >
//                                                                 Edit
//                                                             </button>
//                                                             <button
//                                                                 className={styles.actionMenuItem}
//                                                                 onClick={() => handleAction('Lock Subject', subject)}
//                                                             >
//                                                                 {subject.lockStatus === 'locked' ? 'Unlock Subject' : 'Lock Subject'}
//                                                             </button>
//                                                             <button
//                                                                 className={styles.actionMenuItem}
//                                                                 onClick={() => handleAction('History', subject)}
//                                                             >
//                                                                 History
//                                                             </button>
//                                                             <button
//                                                                 className={`${styles.actionMenuItem} ${styles.actionMenuItemDanger}`}
//                                                                 onClick={() => handleAction('Delete', subject)}
//                                                             >
//                                                                 Delete
//                                                             </button>
//                                                         </>
//                                                     )}
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>

//                 <div className={styles.pagination}>
//                     <div className={styles.rowsPerPage}>
//                         <span className={styles.paginationLabel}>Rows per page:</span>
//                         <select
//                             value={rowsPerPage}
//                             onChange={(e) => setRowsPerPage(Number(e.target.value))}
//                             className={styles.rowsSelect}
//                         >
//                             <option value={10}>10</option>
//                             <option value={25}>25</option>
//                             <option value={50}>50</option>
//                         </select>
//                     </div>

//                     <div className={styles.paginationControls}>
//                         <span className={styles.pageInfo}>Page 1 of 1</span>
//                         <div className={styles.paginationButtons}>
//                             <button className={styles.paginationButton}>
//                                 <ChevronLeft size={18} />
//                             </button>
//                             <button className={styles.paginationButton}>
//                                 <ChevronLeft size={18} />
//                             </button>
//                             <button className={styles.paginationButton}>
//                                 <ChevronRight size={18} />
//                             </button>
//                             <button className={styles.paginationButton}>
//                                 <ChevronRight size={18} />
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Subject Limit Modal */}
//             {showLimitModal && (
//                 <>
//                     <div className={styles.modalBackdrop} onClick={() => setShowLimitModal(false)}></div>
//                     <div className={styles.limitModal}>
//                         <div className={styles.modalHeader}>
//                             <div className={styles.modalIcon}>
//                                 <div className={styles.errorIconCircle}>⚠️</div>
//                             </div>
//                             <button className={styles.modalCloseButton} onClick={() => setShowLimitModal(false)}>
//                                 <X size={20} />
//                             </button>
//                         </div>
//                         <div className={styles.modalContent}>
//                             <h2 className={styles.modalTitle}>Subject Creation Limit Reached</h2>
//                             <p className={styles.modalMessage}>
//                                 You have reached the maximum limit of <strong>{MAX_SUBJECTS_PER_USER} subjects</strong>.
//                             </p>
//                             <p className={styles.modalSubMessage}>
//                                 You currently have <strong>{userSubjectsCount}</strong> subjects created.
//                                 Please contact your administrator if you need to create more subjects.
//                             </p>
//                         </div>
//                         <div className={styles.modalFooter}>
//                             <button
//                                 className={styles.modalButton}
//                                 onClick={() => setShowLimitModal(false)}
//                             >
//                                 I Understand
//                             </button>
//                         </div>
//                     </div>
//                 </>
//             )}

//             {/* Drawer */}
//             {isDrawerOpen && (
//                 <>
//                     <div className={styles.backdrop} onClick={() => setIsDrawerOpen(false)}></div>

//                     <div className={styles.drawer}>
//                         <div className={styles.drawerHeader}>
//                             <h2 className={styles.drawerTitle}>{getDrawerTitle()}</h2>
//                             <button className={styles.closeButton} onClick={() => setIsDrawerOpen(false)}>
//                                 ✕
//                             </button>
//                         </div>

//                         <div className={styles.drawerContent}>
//                             <form className={styles.form}>
//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Site Name <span className={styles.required}>*</span>
//                                     </label>
//                                     {loadingSites ? (
//                                         <div className={styles.loadingText}>Loading sites...</div>
//                                     ) : (
//                                         <>
//                                             <select
//                                                 className={styles.input}
//                                                 name="siteId"
//                                                 value={formData.siteId || ''}
//                                                 onChange={handleInputChange}
//                                                 disabled={isFormDisabled || (drawerMode === 'create' && userAssignedSiteId !== null)}
//                                             >
//                                                 {drawerMode === 'create' ? (
//                                                     <>
//                                                         {userAssignedSiteId ? (
//                                                             sites
//                                                                 .filter(site => site.id === userAssignedSiteId)
//                                                                 .map(site => (
//                                                                     <option key={site.id} value={site.id}>
//                                                                         {site.code} - {site.name} ({site.enrolled}/{site.maxEnrollment})
//                                                                     </option>
//                                                                 ))
//                                                         ) : (
//                                                             <>
//                                                                 <option value="">Select a site</option>
//                                                                 {sites.map(site => (
//                                                                     <option
//                                                                         key={site.id}
//                                                                         value={site.id}
//                                                                         disabled={site.enrolled >= site.maxEnrollment}
//                                                                     >
//                                                                         {site.code} - {site.name} ({site.enrolled}/{site.maxEnrollment})
//                                                                     </option>
//                                                                 ))}
//                                                             </>
//                                                         )}
//                                                     </>
//                                                 ) : (
//                                                     <option value={formData.siteId}>{formData.siteName}</option>
//                                                 )}
//                                             </select>

//                                             {drawerMode === 'create' && userAssignedSiteId && (
//                                                 <div className={styles.siteRestrictionInfo}>
//                                                     <span className={styles.infoIcon}>ℹ️</span>
//                                                     <span className={styles.infoText}>
//                                                         You can only create subjects for your assigned site
//                                                     </span>
//                                                 </div>
//                                             )}
//                                         </>
//                                     )}
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Subject ID <span className={styles.required}>*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         className={styles.input}
//                                         name="subjectId"
//                                         value={formData.subjectId}
//                                         onChange={handleInputChange}
//                                         placeholder="Auto-generated"
//                                         disabled={isFormDisabled}
//                                         readOnly
//                                     />
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Subject Initials <span className={styles.required}>*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         className={styles.input}
//                                         name="subjectInitials"
//                                         value={formData.subjectInitials}
//                                         onChange={handleInputChange}
//                                         placeholder="E.G., JD"
//                                         disabled={isFormDisabled}
//                                     />
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Enrollment Date <span className={styles.required}>*</span>
//                                     </label>
//                                     <input
//                                         type="date"
//                                         className={styles.input}
//                                         name="enrollmentDate"
//                                         value={formData.enrollmentDate}
//                                         onChange={handleInputChange}
//                                         disabled={isFormDisabled}
//                                     />
//                                 </div>

//                                 <div className={styles.formGroup}>
//                                     <label className={styles.label}>
//                                         Enrollment Status <span className={styles.required}>*</span>
//                                     </label>
//                                     <select
//                                         className={styles.input}
//                                         name="enrollmentStatus"
//                                         value={formData.enrollmentStatus}
//                                         onChange={handleInputChange}
//                                         disabled={isFormDisabled}
//                                     >
//                                         <option value="screening">Screening</option>
//                                         <option value="enrolled">Enrolled</option>
//                                         <option value="completed">Completed</option>
//                                         <option value="withdrawn">Withdrawn</option>
//                                         <option value="discontinued">Discontinued</option>
//                                     </select>
//                                 </div>

//                                 {formData.siteId && selectedSite && (
//                                     <div className={styles.formGroup}>
//                                         <label className={styles.label}>Site Enrollment Status</label>
//                                         <div className={styles.statusInfo}>
//                                             <span className={styles.statusIcon}>✓</span>
//                                             <div>
//                                                 <p className={styles.statusTitle}>Enrollment Status</p>
//                                                 <p className={styles.statusSubtitle}>
//                                                     {selectedSite.code} - {selectedSite.name}
//                                                 </p>
//                                                 <p className={styles.statusDetail}>
//                                                     {selectedSite.enrolled} of {selectedSite.maxEnrollment} subjects enrolled
//                                                 </p>
//                                                 <div className={styles.progressBar}>
//                                                     <div
//                                                         className={styles.progressFill}
//                                                         style={{ width: `${selectedSite.progress}%` }}
//                                                     ></div>
//                                                 </div>
//                                                 <p className={styles.statusText}>
//                                                     {selectedSite.enrolled < selectedSite.maxEnrollment ? (
//                                                         <span className={styles.greenText}>
//                                                             ✓ {selectedSite.maxEnrollment - selectedSite.enrolled} enrollment slot{selectedSite.maxEnrollment - selectedSite.enrolled !== 1 ? 's' : ''} remaining
//                                                         </span>
//                                                     ) : (
//                                                         <span className={styles.redText}>
//                                                             ✕ Enrollment limit reached
//                                                         </span>
//                                                     )}
//                                                 </p>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </form>
//                         </div>

//                         <div className={styles.drawerFooter}>
//                             {drawerMode === 'view' ? (
//                                 <button className={styles.cancelButton} onClick={() => setIsDrawerOpen(false)}>
//                                     Close
//                                 </button>
//                             ) : drawerMode === 'edit' ? (
//                                 <>
//                                     <button className={styles.cancelButton} onClick={() => setIsDrawerOpen(false)}>
//                                         Cancel
//                                     </button>
//                                     <button className={styles.primaryButton} onClick={handleUpdateSubject}>
//                                         Save Changes
//                                     </button>
//                                 </>
//                             ) : (
//                                 <>
//                                     <button className={styles.cancelButton} onClick={() => setIsDrawerOpen(false)}>
//                                         Cancel
//                                     </button>
//                                     <button className={styles.enrollButton} onClick={handleEnrollSubject}>
//                                         Enroll New Subject
//                                     </button>
//                                     <button className={styles.primaryButton} onClick={handleCreateAndStartCapture}>
//                                         Create and Start Capture
//                                     </button>
//                                 </>
//                             )}
//                         </div>
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default DataCapture;

// import React, { useState } from 'react';
// import styles from './StudyManagement.module.css';
// import DataCaptureHeader from './Componets/DataCaptureHeader';
// import EnrollmentCards from './Componets/Enrollement';
// import SubjectsTable from './Componets/SubjectsTable';
// import SubjectDrawer from './Componets/SubjectDrawer';
// import SubjectLimitModal from './Componets/SubjectModal';
// import { useDataCapture } from './hooks';

// const DataCapture = () => {
//     const [isDrawerOpen, setIsDrawerOpen] = useState(false);
//     const [drawerMode, setDrawerMode] = useState('create');
//     const [selectedSubject, setSelectedSubject] = useState(null);

//     const {
//         subjects,
//         sites,
//         loadingSites,
//         canWrite,
//         userAssignedSiteId,
//         userSite,
//         userSubjectsCount,
//         studyData,
//         showLimitModal,
//         setShowLimitModal,
//         checkSubjectLimit,
//         checkSiteEnrollmentLimit,
//         addSubject,
//         updateSubject,
//         deleteSubject,
//         toggleSubjectLock,
//         generateSubjectId
//     } = useDataCapture();

//     const handleCreateClick = () => {
//         if (!checkSubjectLimit()) return;
//         setDrawerMode('create');
//         setSelectedSubject(null);
//         setIsDrawerOpen(true);
//     };

//     const handleViewSubject = (subject) => {
//         setDrawerMode('view');
//         setSelectedSubject(subject);
//         setIsDrawerOpen(true);
//     };

//     const handleEditSubject = (subject) => {
//         setDrawerMode('edit');
//         setSelectedSubject(subject);
//         setIsDrawerOpen(true);
//     };

//     const handleDrawerSubmit = async (formData) => {
//         if (!checkSubjectLimit()) return;

//         if (drawerMode === 'create') {
//             const result = await addSubject(formData);
//             if (result && result.success) {
//                 setIsDrawerOpen(false);
//             }
//         } else if (drawerMode === 'edit') {
//             updateSubject(formData.subjectId, formData);
//             setIsDrawerOpen(false);
//         }
//     };

//     const handleCreateAndCapture = async (formData) => {
//         if (!checkSubjectLimit()) return;
//         const result = await addSubject(formData);
//         if (result && result.success) {
//             setIsDrawerOpen(false);
//         }
//     };

//     return (
//         <div className={styles.container}>
//             <DataCaptureHeader />

//             <EnrollmentCards
//                 subjects={subjects}
//                 studyData={studyData}
//                 userSite={userSite}
//             />

//             <SubjectsTable
//                 subjects={subjects}
//                 sites={sites}
//                 canWrite={canWrite}
//                 onCreateClick={handleCreateClick}
//                 onViewSubject={handleViewSubject}
//                 onEditSubject={handleEditSubject}
//                 onDeleteSubject={deleteSubject}
//                 onLockSubject={toggleSubjectLock}
//             />

//             <SubjectDrawer
//                 isOpen={isDrawerOpen}
//                 onClose={() => setIsDrawerOpen(false)}
//                 mode={drawerMode}
//                 initialData={selectedSubject}
//                 sites={sites}
//                 loadingSites={loadingSites}
//                 userAssignedSiteId={userAssignedSiteId}
//                 onSubmit={handleDrawerSubmit}
//                 onCreateAndCapture={handleCreateAndCapture}
//                 generateSubjectId={generateSubjectId}
//                 checkSiteLimit={checkSiteEnrollmentLimit}
//             />

//             <SubjectLimitModal
//                 show={showLimitModal}
//                 onClose={() => setShowLimitModal(false)}
//                 userSubjectsCount={userSubjectsCount}
//             />
//         </div>
//     );
// };

// export default DataCapture;

import React, { useState } from 'react';
import styles from './StudyManagement.module.css';
import DataCaptureHeader from './Componets/DataCaptureHeader';
import EnrollmentCards from './Componets/Enrollement';
import SubjectsTable from './Componets/SubjectsTable';
import SubjectDrawer from './Componets/SubjectDrawer';
import SubjectLimitModal from './Componets/SubjectModal';
import { useDataCapture } from './hooks';

const DataCapture = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerMode, setDrawerMode] = useState('create');
    const [selectedSubject, setSelectedSubject] = useState(null);

    const {
        subjects,
        sites,
        loadingSites,
        canWrite,
        canDataCapture,
        userAssignedSiteId,
        userSite,
        userSubjectsCount,
        studyData,
        showLimitModal,
        setShowLimitModal,
        checkSubjectLimit,
        checkSiteEnrollmentLimit,
        addSubject,
        updateSubject,
        deleteSubject,
        toggleSubjectLock,
        generateSubjectId
    } = useDataCapture();

    const handleCreateClick = () => {
        if (!checkSubjectLimit()) return;
        setDrawerMode('create');
        setSelectedSubject(null);
        setIsDrawerOpen(true);
    };

    const handleViewSubject = (subject) => {
        setDrawerMode('view');
        setSelectedSubject(subject);
        setIsDrawerOpen(true);
    };

    const handleEditSubject = (subject) => {
        setDrawerMode('edit');
        setSelectedSubject(subject);
        setIsDrawerOpen(true);
    };

    const handleDrawerSubmit = async (formData) => {
        if (!checkSubjectLimit()) return;

        if (drawerMode === 'create') {
            const result = await addSubject(formData);
            if (result && result.success) {
                setIsDrawerOpen(false);
            }
        } else if (drawerMode === 'edit') {
            updateSubject(formData.subjectId, formData);
            setIsDrawerOpen(false);
        }
    };

    const handleCreateAndCapture = async (formData) => {
        if (!checkSubjectLimit()) return;
        const result = await addSubject(formData);
        if (result && result.success) {
            setIsDrawerOpen(false);
        }
    };

    return (
        <div className={styles.container}>
            <DataCaptureHeader />

            <EnrollmentCards
                subjects={subjects}
                studyData={studyData}
                userSite={userSite}
            />

            <SubjectsTable
                subjects={subjects}
                sites={sites}
                canWrite={canWrite}
                canDataCapture={canDataCapture}
                onCreateClick={handleCreateClick}
                onViewSubject={handleViewSubject}
                onEditSubject={handleEditSubject}
                onDeleteSubject={deleteSubject}
                onLockSubject={toggleSubjectLock}
            />

            {isDrawerOpen && <SubjectDrawer
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
                mode={drawerMode}
                initialData={selectedSubject}
                sites={sites}
                loadingSites={loadingSites}
                userAssignedSiteId={userAssignedSiteId}
                onSubmit={handleDrawerSubmit}
                onCreateAndCapture={handleCreateAndCapture}
                generateSubjectId={generateSubjectId}
                checkSiteLimit={checkSiteEnrollmentLimit}
            />}

            <SubjectLimitModal
                show={showLimitModal}
                onClose={() => setShowLimitModal(false)}
                userSubjectsCount={userSubjectsCount}
            />
        </div>
    );
};

export default DataCapture;